export default function () {
    const winnersContainer = document.querySelector('.winners-grid');
    if (winnersContainer) {    
        fetch('https://blog.lotteryoffice.com.au/wp-json/wp/v2/posts?per_page=10&categories=28', { method: 'GET' })
            .then(response => response.json())
            .then(response => {
                //filter by featured, truncate to only 3
                populateWinnersSection(response.filter((winner) => winner.acf.feature_on_homepage == true).slice(0, 4))
            }).catch((error) => {
                winnersContainer.style.display = 'none';
            });
    }

    function populateWinnersSection(data) {
        if (!data) {
            winnersContainer.style.display = 'none';
            return;
        }

        let winnersGrid = document.getElementById('winners-grid');

        let winnersData = data.map((winner) => {
           return `
                <div class="winner-block d-flex">
                <a href="${winner.acf.winner_url}">
                    <img src="${winner.acf.winner_image}" alt="Lottery Winner" loading="lazy" width="240" height="183" />
                    <p class="date">${winner.acf.winner_date}</p>

                    <p>
                       ${winner.acf.winner_title}
                    </p>
                    <span>${winner.acf.winner_label}</span>
                </a>
            </div>`
        }).join('');

        winnersGrid.insertAdjacentHTML('afterbegin', winnersData);
     }
}


// WEBPACK FOOTER //
// ./assets/src/js/classes/homepageWinners.js